"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Dialog = require("../../components/Dialog/Dialog.styles");
var _DialogActions = require("../../components/DialogActions/DialogActions.styles");
var _DialogBody = require("../../components/DialogBody/DialogBody.styles");
var _DialogClose = require("../../components/DialogClose/DialogClose.styles");
var _DialogHeader = require("../../components/DialogHeader/DialogHeader.styles");
var _PopoverArrow = require("../../components/PopoverArrow/PopoverArrow.styles");
var _PopoverIcon = require("../../components/PopoverIcon/PopoverIcon.styles");
var _Text = require("../../components/Text/Text.styles");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _mediaQueryMixin = require("../mediaQueryMixin");
var _overflowAutoMixin = require("../overflowAutoMixin");
var _overflowPaddingMixin = require("../overflowPaddingMixin");
var _spaceMixin = require("../spaceMixin");
var _typographyMixin = require("../typographyMixin");
var _DialogMixin = require("./DialogMixin");
var _ModalMixin = require("./ModalMixin");
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  if (!appearance) {
    return '';
  }
  return (0, _styledToken.default)({
    background: "status." + appearance + ".background",
    foreground: "status." + appearance + ".foreground"
  }, function (tokens) {
    return (0, _styledComponents.css)(["", "{background-color:", ";border-color:", ";}", "{color:", ";}&[data-popper-placement^='bottom'] ", ":after{background-color:", ";}"], _DialogHeader.StyledDialogHeader, tokens.background, tokens.background, _PopoverIcon.StyledPopoverIcon, tokens.foreground, _PopoverArrow.StyledPopoverArrow, tokens.background);
  })(props);
};
var iconCSS = function iconCSS(props) {
  if (!props.icon) {
    return '';
  }
  return (0, _styledToken.default)({
    iconSize: 'Popover.icon.size',
    padding: 'Popover.padding'
  }, function (_ref) {
    var iconSize = _ref.iconSize,
      padding = _ref.padding;
    return (0, _styledComponents.css)(["", "{position:absolute;top:", "px;left:", "px;}", "{padding-left:", "px;}"], _PopoverIcon.StyledPopoverIcon, padding, padding, _DialogHeader.StyledDialogHeader, (0, _spaceMixin.spaceMixin)('xs', function (space) {
      return space.value + padding + iconSize;
    })(props));
  })(props);
};
var arrowCSS = (0, _styledToken.default)('Popover.arrowOuterSize', function (arrowOuterSize) {
  return (0, _styledComponents.css)(["", "{position:absolute;display:block;}&[data-popper-placement^='top'] ", "{bottom:-", "px;}&[data-popper-placement^='right'] ", "{left:-", "px;}&[data-popper-placement^='bottom'] ", "{top:-", "px;}&[data-popper-placement^='left'] ", "{right:-", "px;}"], _PopoverArrow.StyledPopoverArrow, _PopoverArrow.StyledPopoverArrow, arrowOuterSize, _PopoverArrow.StyledPopoverArrow, arrowOuterSize, _PopoverArrow.StyledPopoverArrow, arrowOuterSize, _PopoverArrow.StyledPopoverArrow, arrowOuterSize);
});
var dialogCSS = function dialogCSS(props) {
  return (0, _styledToken.default)({
    zIndex: 'Popover.Dialog.zIndex',
    borderRadius: 'Popover.Dialog.borderRadius',
    maxWidth: 'Dialog.maxWidth',
    maxHeight: 'Popover.maxHeight',
    padding: 'Popover.padding',
    separatorColor: 'Popover.separatorColor',
    headingFontType: 'Popover.headingFontType',
    backgroundColor: 'Dialog.backgroundColor',
    separatorWidth: 'Popover.separatorWidth',
    gradientDirection: 'Popover.Dialog.gradientDirection',
    startingColor: 'Popover.Dialog.startingColor',
    startingColorPosition: 'Popover.Dialog.startingColorPosition',
    endingColorPosition: 'Popover.Dialog.endingColorPosition'
  }, function (_ref2) {
    var zIndex = _ref2.zIndex,
      borderRadius = _ref2.borderRadius,
      maxWidth = _ref2.maxWidth,
      maxHeight = _ref2.maxHeight,
      padding = _ref2.padding,
      separatorColor = _ref2.separatorColor,
      headingFontType = _ref2.headingFontType,
      backgroundColor = _ref2.backgroundColor,
      _ref2$separatorWidth = _ref2.separatorWidth,
      separatorWidth = _ref2$separatorWidth === void 0 ? 1 : _ref2$separatorWidth,
      _ref2$gradientDirecti = _ref2.gradientDirection,
      gradientDirection = _ref2$gradientDirecti === void 0 ? '180deg' : _ref2$gradientDirecti,
      _ref2$startingColor = _ref2.startingColor,
      startingColor = _ref2$startingColor === void 0 ? 'rgba(255, 255, 255, 0)' : _ref2$startingColor,
      _ref2$startingColorPo = _ref2.startingColorPosition,
      startingColorPosition = _ref2$startingColorPo === void 0 ? '0%' : _ref2$startingColorPo,
      _ref2$endingColorPosi = _ref2.endingColorPosition,
      endingColorPosition = _ref2$endingColorPosi === void 0 ? '100%' : _ref2$endingColorPosi;
    return (0, _styledComponents.css)(["", " z-index:", ";display:flex;flex-direction:column;border-radius:", "px;width:100%;max-width:", "px;max-height:", "px;", "{padding:", "px;padding-right:calc(", "px + ", ");border-bottom:", "px solid ", ";border-top-left-radius:", "px;border-top-right-radius:", "px;", "{", "}}", "{padding-top:", "px;}", "{", " ", " _:-ms-fullscreen &,&{flex-basis:150px;}}transform:translate3d(0,0,0);&:after{content:'';position:absolute;left:", "px;right:", "px;bottom:0;height:", "px;background:linear-gradient( ", ",", " ", ",", " ", " );}", "{right:", "px;top:", "px;}", " ", " ", ""], (0, _DialogMixin.DialogMixin)(props), zIndex, borderRadius, maxWidth, maxHeight, _DialogHeader.StyledDialogHeader, padding, padding, (0, _spaceMixin.spaceMixin)('lg')(props), separatorWidth, separatorColor, borderRadius, borderRadius, _Text.StyledText, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: headingFontType
    }, props)), _DialogActions.StyledDialogActions, padding, _DialogBody.StyledDialogBody, (0, _overflowAutoMixin.overflowAutoMixin)(props), (0, _overflowPaddingMixin.overflowPaddingMixin)(padding + "px", padding + "px", padding + "px")(props), padding, padding, padding, gradientDirection, startingColor, startingColorPosition, backgroundColor, endingColorPosition, _DialogClose.StyledDialogClose, padding, padding, appearanceCSS(props), arrowCSS(props), iconCSS(props));
  })(props);
};
var modalCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('modal', function (mediaProps) {
  if (!mediaProps.modal) {
    return '';
  }
  return (0, _styledComponents.css)(["", " > ", "{transform:none !important;position:relative !important;> ", "{display:none;}}"], (0, _ModalMixin.ModalMixin)(mediaProps), _Dialog.StyledDialog, _PopoverArrow.StyledPopoverArrow);
});
var popoverCSS = function popoverCSS(props) {
  return (0, _styledComponents.css)(["> ", "{", "}", ""], _Dialog.StyledDialog, dialogCSS(props), modalCSS(props));
};

/** @class PopoverMixin */
/** @method */
var PopoverMixin = function PopoverMixin(props) {
  return [popoverCSS(props), (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
    return popoverCSS(Object.assign({}, props, mediaProps));
  })];
};
exports.PopoverMixin = PopoverMixin;